module.exports = __webpack_public_path__ + "static/media/Thumbsup.d77f6d76.png";